module.exports = __webpack_public_path__ + "img/stackslash-inspect-portrait.a6bd6ef4.jpg";